// source: witbooking/backoffice/property/v1/property_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetParentTickerRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetParentTickerResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.displayName = 'proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetParentTickerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetParentTickerRequest.displayName = 'proto.witbooking.backoffice.property.v1.GetParentTickerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.GetParentTickerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse.displayName = 'proto.witbooking.backoffice.property.v1.GetParentTickerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.displayName = 'proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.displayName = 'proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest;
  return proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string query = 1;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse;
  return proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPropertyTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string property_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.getPropertyTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.setPropertyTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.addPropertyTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyTickersResponse.prototype.clearPropertyTickersList = function() {
  return this.setPropertyTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest;
  return proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    partner: jspb.Message.getFieldWithDefault(msg, 2, ""),
    group: jspb.Message.getFieldWithDefault(msg, 3, ""),
    localesList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    defaultCurrency: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse;
  return proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartner(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroup(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addLocales(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartner();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getGroup();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLocalesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getDefaultCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string partner = 2;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.getPartner = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.setPartner = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string group = 3;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.getGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.setGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string locales = 4;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.getLocalesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.setLocalesList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.addLocales = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.clearLocalesList = function() {
  return this.setLocalesList([]);
};


/**
 * optional string default_currency = 5;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.getDefaultCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyInfoResponse.prototype.setDefaultCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    configurationKeysList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest;
  return proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addConfigurationKeys(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigurationKeysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string configuration_keys = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.getConfigurationKeysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.setConfigurationKeysList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.addConfigurationKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationRequest.prototype.clearConfigurationKeysList = function() {
  return this.setConfigurationKeysList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configurationsMap: (f = msg.getConfigurationsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse;
  return proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getConfigurationsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigurationsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> configurations = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.prototype.getConfigurationsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyConfigurationResponse.prototype.clearConfigurationsMap = function() {
  this.getConfigurationsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest;
  return proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    propertyTickersList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse;
  return proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addPropertyTickers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPropertyTickersList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string property_tickers = 1;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.getPropertyTickersList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.setPropertyTickersList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.addPropertyTickers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetPropertyChildrenResponse.prototype.clearPropertyTickersList = function() {
  return this.setPropertyTickersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetParentTickerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetParentTickerRequest;
  return proto.witbooking.backoffice.property.v1.GetParentTickerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetParentTickerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetParentTickerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.GetParentTickerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    parentTicker: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.GetParentTickerResponse;
  return proto.witbooking.backoffice.property.v1.GetParentTickerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentTicker(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.GetParentTickerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParentTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string parent_ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.prototype.getParentTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.property.v1.GetParentTickerResponse} returns this
 */
proto.witbooking.backoffice.property.v1.GetParentTickerResponse.prototype.setParentTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    childrenList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest;
  return proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string children = 2;
 * @return {!Array<string>}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.getChildrenList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} returns this
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.setChildrenList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} returns this
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.addChildren = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest} returns this
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainRequest.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse;
  return proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.property.v1.CreatePropertyChainResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.witbooking.backoffice.property.v1);
